type Props = {
  caption: string
}

export const LoadingProgress = ({ caption }: Props) => {
  return (
    <div className='flex flex-col'>
      <div>{ caption }</div>
      <div className='w-full'>
        <div className='h-1.5 w-full bg-blue-100 overflow-hidden'>
          <div className='animate-progress w-full h-full bg-jw-blue origin-left-right'></div>
        </div>
      </div>
    </div>
  );
};
